import { useContext, useMemo } from 'react';

import { PlusOutlined, MinusOutlined } from '@ant-design/icons';

import {
  ColSize,
  ContentSection,
  Form,
  InputNumberForm,
  RowSize,
  SelectForm,
} from '../../../../../../../../../../../shared/components';

import { GenericDataFormContext } from '../../../../../../../shared/contexts';
import { StepThreeFormContext } from '../../../../contexts/StepThreeForm';
import { QUOTATION_BUTTON } from '../../../../../../../shared';

export const PaymentMethods = () => {
  const { paymentMethods } = useContext(GenericDataFormContext);

  const {
    clearPrimaFieldsOnFormChange,
    maxAndMinVariation,
    paymentMethodsForm,
    quotationResponse,
    setLabelButton,
    initialPaymentMethodForm,
  } = useContext(StepThreeFormContext);

  const prevValues = useMemo(
    () => ({
      prevEPVValue:
        quotationResponse?.primaPremioOperacion.porcentajeExtraPrimaVariable,
      prevCommissionValue:
        quotationResponse?.primaPremioOperacion.porcentajeComision,
      /* eslint-disable-next-line */
    }),
    [quotationResponse]
  );

  //* on change variation set epv and commission value, and set state for requote.
  const onPaymentsMethodFormChange = (valueChanged: { variation: number }) => {
    setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
    clearPrimaFieldsOnFormChange();

    if (valueChanged?.variation?.toString().length) {
      const prevCommissionValue = Number(prevValues.prevCommissionValue);
      const prevEPVValue = Number(prevValues.prevEPVValue);

      if (prevCommissionValue !== undefined && prevEPVValue !== undefined) {
        paymentMethodsForm.setFieldValue(
          'extraVariable',
          prevEPVValue + valueChanged.variation
        );
        paymentMethodsForm.setFieldValue(
          'commission',
          prevCommissionValue + valueChanged.variation
        );
      }
    }
  };

  return (
    <Form
      formProps={{
        form: paymentMethodsForm,
        name: 'payment-methods-form',
        onValuesChange: onPaymentsMethodFormChange,
        initialValues: initialPaymentMethodForm
      }}
    >
      <ContentSection level='h3' title='Forma de pago y comisiones'>
        <RowSize>
          <ColSize size={20}>
            <SelectForm
              formProps={{
                label: 'Forma de pago:',
                name: 'paymentMethod',
              }}
              selectProps={{
                options: paymentMethods,
                placeholder: 'Seleccionar',
              }}
            />
          </ColSize>

          <ColSize size={20}>
            <InputNumberForm
              formProps={{
                label: 'Comisión:',
                name: 'commission',
              }}
              inputNumberProps={{
                disabled: true,
                precision: 2,
                readOnly: true,
              }}
            />
          </ColSize>

          <ColSize size={20}>
            <InputNumberForm
              formProps={{
                label: 'Extra prima variable:',
                name: 'extraVariable',
              }}
              inputNumberProps={{
                disabled: true,
                precision: 2,
                readOnly: true,
              }}
            />
          </ColSize>

          <ColSize size={20}>
            <InputNumberForm
              formProps={{
                initialValue: 0,
                label: 'Variación:',
                name: 'variation',
              }}
              inputNumberProps={{
                controls: {
                  upIcon: <PlusOutlined />,
                  downIcon: <MinusOutlined />,
                },
                addonAfter: '%',
                max: maxAndMinVariation?.max,
                min: maxAndMinVariation?.min,
              }}
            />
          </ColSize>
        </RowSize>
      </ContentSection>
    </Form>
  );
};
